import type { WithConversationId } from '../model'
import { type WithOptionalScheme, withScheme } from './util'

export const toConversationList = ({ includeScheme = false }: WithOptionalScheme): string => {
  return withScheme(`conversation`, includeScheme)
}

export const toConversation = ({
  convoId,
  defaultTab,
  includeScheme = false,
}: WithConversationId &
  WithOptionalScheme & {
    defaultTab?: 'insights' | 'feedback' | 'transcript'
  }): string => {
  if (defaultTab) {
    return withScheme(`conversation/${convoId}/${defaultTab}`, includeScheme)
  }
  return withScheme(`conversation/${convoId}`, includeScheme)
}
